export default "__VITE_ASSET__B$BCtdew__"